import { TextField } from "@mui/material";
import {
  DatePicker,
  DatePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import i18n from "../../../pages/i18n/I18n";
import dayjs from "dayjs";

// impotação dos idiomas suportados
import "dayjs/locale/pt-br";
import "dayjs/locale/en";
import "dayjs/locale/es";



type DatePickerWithLocaleProps = Omit<
  DatePickerProps<Dayjs, Dayjs>,
  "value" | "onChange" | "renderInput"
> & {
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
  locale?: string;
  placeholder?: string;
  renderInput?: DatePickerProps<Dayjs, Dayjs>["renderInput"];
};

export default function DatePickerWithLocale({
  value,
  onChange,
  renderInput,
  locale,
  ...props
}: DatePickerWithLocaleProps) {
  const { t } = useTranslation();

  const adapterLocale =
    locale ?? (i18n.language.startsWith("pt") ? "pt-br" : i18n.language.startsWith("es")? "es" : "en");

  dayjs.locale(adapterLocale);
  
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={adapterLocale}
    >
      <DatePicker
        {...props}
        inputFormat="DD/MM/YYYY"
        value={value}
        onChange={onChange}
        renderInput={renderInput?renderInput:(params) => (
          <TextField
            {...params}
            variant="standard"
            fullWidth
            inputProps={{
              ...params.inputProps,
              placeholder: t("ButtonWithPopoverFilter.end"),
              autoComplete: "off"
            }}
            sx={{ width: "150px" }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
